
<template>
  <v-file-input :accept='type' label="File input"  @change="changeData($event)"></v-file-input>
</template>

<script>
export default {
  name: "FileUpload",
  props: ['type'],

  methods: {
    changeData(event) {
      this.$emit("changeFile", event);
    }
  }
};
</script>